var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-1"},[_c('p',[_vm._v(_vm._s(_vm.$t('Build your own custom FAQ solution using our API')))]),_vm._v(" "),_c('a',{attrs:{"href":"/api-docs/"}},[_vm._v("\n    "+_vm._s(_vm.$t('Check out our API documentation'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }